import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import apis from "../../../context/api";
import CompleteOrder from "./CompleteOrder";

const API_URL = "http://localhost:3000/api";
const AUTH_HEADER = {
  Authorization: "Bearer f5853f45e5ae57c210488e60810de703d91b39672b01425fd8c9b50e531b791b",
  "Content-Type": "application/json",
};

// eslint-disable-next-line react/prop-types
function OrderEdit({ id, onSuccess, onCancel }) {
  const [products, setProducts] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [customer, setCustomer] = useState(null);
  const [grandTotal, setGrandTotal] = useState(0);
  const [comboData, setComboData] = useState({
    name: "",
    shortName: "",
    items: [],
    customerId: null,
    discount: "",
    userId: null,
  });
  const [error, setError] = useState(null);

  useEffect(() => {
    apis
      .getProducts()
      .then((data) => setProducts(data))
      .catch(() => setError("Failed to load products"));
    apis
      .getCustomers()
      .then((data) => setCustomers(data))
      .catch(() => setError("Failed to load customers"));

    if (id) {
      loadData(id);
    }
  }, []);
  const loadData = (id) => {
    apis
      .getQuotationById(id)
      .then((data) => {
        setComboData(data);
        setCustomer(data.customer);
        calculateTotal(data.items);
      })
      .catch(() => setError("Failed to load quotation"));
  };

  const calculateTotal = (updatedItems) => {
    let total = 0;
    updatedItems.forEach((item) => {
      const product = products.find((p) => p.id === item.productId);
      const price = item.sellingPrice ?? product?.sellingPrice ?? 0;
      const quantity = item.quantity ?? 1;
      total += price * quantity;
    });
    setGrandTotal(total.toFixed(2));
  };
  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    }
  };
  const onDelivered = (id, date) => {
    apis
      .completeOrder(id, date)
      .then((res) => {
        loadData(id);
      })
      .catch((err) => {
        console.error("Data loading error:", err);
      });
  };
  const sendInvoice = () => {
    apis
      .sendAndDownloadInvoice(id)
      .then((res) => {
        const url = window.URL.createObjectURL(res);

        // Create a temporary link to trigger download
        const a = document.createElement("a");
        a.href = url;
        a.target = "_blank";
        a.download = "invoice.pdf";
        document.body.appendChild(a);
        a.click();
        a.remove();

        window.URL.revokeObjectURL(url); // Clean up
      })
      .catch((err) => {
        console.error("Data loading error:", err);
      });
  };

  const selectedProducts = comboData.items
    .map((p) => products.find((prod) => prod.id === p.productId))
    .filter(Boolean);

  return (
    <MDBox pt={6} pb={6}>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Card>
            <MDBox p={5}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Autocomplete
                    options={customers}
                    getOptionLabel={(option) => option.name || ""}
                    value={customer}
                    renderInput={(params) => <TextField {...params} label="Select Customer" />}
                    fullWidth
                    disabled={true}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Autocomplete
                    multiple
                    options={products}
                    getOptionLabel={(option) => option.productShortName || ""}
                    value={selectedProducts}
                    disabled={true}
                    renderInput={(params) => (
                      <TextField {...params} label="Select Products by Short Name" />
                    )}
                    fullWidth
                  />
                </Grid>

                {comboData.items.map((item) => {
                  const product = products.find((p) => p.id === item.productId);
                  return (
                    <Grid
                      container
                      spacing={1}
                      p={2}
                      key={item.productId}
                      alignItems="center"
                      mt={1}
                    >
                      <Grid item xs={6}>
                        <MDInput
                          label={product?.productShortName + " quantity" || "Product" + " quantity"}
                          value={item.quantity}
                          type="number"
                          inputProps={{ min: 1 }}
                          disabled={true}
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <MDInput
                          label={product?.productShortName + " price" || "Product" + " price"}
                          value={item.sellingPrice}
                          type="number"
                          disabled={true}
                          fullWidth
                        />
                      </Grid>
                    </Grid>
                  );
                })}
              </Grid>
              <Grid item xs={12}>
                <MDBox mt={2} fontWeight="bold">
                  Total Amount: ₹ {grandTotal}
                </MDBox>
              </Grid>

              <Grid container justifyContent="flex-end" pt={4}>
                <Grid item pl={2} pr={2} xs="auto">
                  <MDButton variant="gradient" color="warning" onClick={handleCancel}>
                    Cancel
                  </MDButton>
                </Grid>
                <Grid item pl={2} pr={2} xs="auto">
                  {!comboData.deliveryDate && (
                    <CompleteOrder id={comboData.id} onDelivered={onDelivered}></CompleteOrder>
                  )}
                  {comboData.deliveryDate && (
                    <MDButton variant="gradient" color="info" onClick={sendInvoice}>
                      Invoice
                    </MDButton>
                  )}
                </Grid>
              </Grid>

              {error && (
                <MDBox mt={2} color="error">
                  <strong>{error}</strong>
                </MDBox>
              )}
            </MDBox>
          </Card>
        </Grid>
      </Grid>
    </MDBox>
  );
}

export default OrderEdit;
